module.exports = __webpack_public_path__ + "assets/img/eu-hero.1f0adac1.webp";